module.exports = __webpack_public_path__ + "static/img/charm_level_80.3761dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/charm_level_80.png
// module id = nL+f
// module chunks = 0